import React from 'react';
import { Form, Input } from 'antd';
import { Control, Controller } from 'react-hook-form';
import { CreateAccountAndUser } from '@quick/client';
import AddressFormItems from '../components/AddressFormItems';

interface AccountInformationFormProps {
  control: Control<CreateAccountAndUser>;
}

const AccountInformationForm: React.FC<AccountInformationFormProps> = ({ control }) => {
  return (
    <Form layout="vertical" preserve colon={false} requiredMark={false}>
      <h6 className="my-6">Tell us about your business</h6>
      <Controller
        control={control}
        name="name"
        rules={{
          required: 'Business name is required',
        }}
        render={({ field, fieldState }) => (
          <Form.Item
            required
            label="Business name"
            validateStatus={fieldState.error && 'error'}
            help={fieldState.error?.message}
            tooltip="The doing business as (DBA) name"
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
      <AddressFormItems control={control} />
      <Controller
        control={control}
        name="taxId"
        rules={{
          minLength: {
            value: 9,
            message: 'Tax ID has at least 9 digits',
          },
          required: 'Tax ID is required',
        }}
        render={({ field, fieldState }) => (
          <Form.Item
            required
            label="Tax ID"
            validateStatus={fieldState.error && 'error'}
            help={fieldState.error?.message}
            tooltip="Your Employer Identification Number (EIN)"
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
    </Form>
  );
};

export default AccountInformationForm;
